import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import session from './modules/session'
import processes from './modules/processes'
import tenants from './modules/tenants'
import avatar from './modules/avatar'
import SecureLS from "secure-ls";
import terms from './modules/terms'
import topics_subtopics from "./modules/topics_subtopics";
import compliance from "./modules/compliances";
import dashboard from "./modules/dashboard"

let ls = new SecureLS({encodingType: 'aes', isCompression: true});

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        moduleSession: session,
        moduleProcesses: processes,
        moduleTenants: tenants,
        moduleAvatar: avatar,
        moduleTerms: terms,
        moduleTopicsSubtopics: topics_subtopics,
        moduleCompliance: compliance,
        moduleDashboard: dashboard
    },
    plugins: [createPersistedState({
        key: 'alinea',
        storage: {
            getItem: (alinea) => ls.get(alinea),
            setItem: (alinea, value) => ls.set(alinea, value),
            removeItem: (alinea) => ls.remove(alinea),
        },
    })]
})
